module.exports = __webpack_public_path__ + "static/fintech-poland-logo-8d11901f00d535c00f5ea41a193700dd.png";